import { render, staticRenderFns } from "./DocumentAssetListItem.vue?vue&type=template&id=655338c4&scoped=true"
import script from "./DocumentAssetListItem.vue?vue&type=script&lang=js"
export * from "./DocumentAssetListItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentAssetListItem.vue?vue&type=style&index=0&id=655338c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655338c4",
  null
  
)

export default component.exports